'use strict';

var d3 = require('d3');
var CompetitorFaresChart = function CompetitorFaresChart(AbstractChart, chartXAxis, chartYAxis, chartConstants, chartCurves, chartPoints, chartZoom, chartHoverOver, chartRectClip, chartVerticalLine, $location, userPreferencesService) {
  var chartParamsBuilder = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters, isExpandedModeEnabled) {
    var self = this;
    var userPref = userPreferencesService.getUserDateTimeSettings('defaultRTPView');
    var axisMode = userPref === 'right-to-left' ? chartConstants.AXIS.MODE.RIGHT : chartConstants.AXIS.MODE.LEFT;
    var params = chartParamsBuilder(userPref, isExpandedModeEnabled);
    var dispatch = d3.dispatch('rangechange');
    var curves = chartCurves('dtd', 'value', 'curveData');
    var points = chartPoints('dtd', 'value', 'pointData', 2);
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).label('Days to Departure');
    var verticalLine = chartVerticalLine('dtd', 'caption');
    AbstractChart.call(this, container);
    d3.rebind(this, dispatch, 'on');
    var yAxis = chartYAxis(formatters.yAxisTickFormatter, axisMode).withoutHorizontalLines();
    if (axisMode === chartConstants.AXIS.MODE.RIGHT) {
      yAxis = yAxis.withLabelRotation(-90);
    }
    var hoverOver = chartHoverOver('curveData', 'dtd', 'value', formatters.tooltipFormatter, undefined, formatters.tooltipFormatter.cssClass, formatters.checkForMatchedFilter);
    this.render = function (data, verticalLineData) {
      var clipPathId = 'competitor-fares-chart-clip';
      d3.select('#' + clipPathId).remove();
      this.initChart(data, undefined, params);
      var verticalLineWithData = verticalLine.withData(verticalLineData).chartXAxisWidth(this.container.width() - this.params.padding.right + this.params.yAxisShift);
      this.scales = chartScales(this.params, this.data, userPref);
      var zoom = chartZoom();
      var rectClip = chartRectClip();
      curves.clipPath($location.path() + '#' + clipPathId);
      points.clipPath($location.path() + '#' + clipPathId);
      this.svg.call(rectClip.id(clipPathId).x(0).y(-this.params.padding.bottom).width(this.container.width() - this.params.padding.right).height(this.container.height()));
      this.callForDataGroup([yAxis, curves, points, hoverOver, verticalLineWithData, xAxis], this.scales);
      var redrawElementsWrapper = function redrawElementsWrapper() {
        this.callForDataGroup.call(this, [curves, points, verticalLineWithData, xAxis, hoverOver]);
      };
      this.svg.call(zoom.params(this.params).scales(this.scales).toRedraw([redrawElementsWrapper.bind(this)]));
    };
    this.withMetric = function (metric) {
      yAxis.label(metric);
      return this;
    };

    /**
     * Stops propagation of mouse events so it would not mess with carousel
     */
    function bindEvents() {
      var stopPropagation = function stopPropagation() {
        d3.event.stopPropagation();
      };
      self.svg.on('mouseover', stopPropagation);
      self.svg.on('mouseout', stopPropagation);
      self.svg.on('mousedown', stopPropagation);
      self.svg.on('click', stopPropagation);
    }
    bindEvents();
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
CompetitorFaresChart.$inject = ['AbstractChart', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'ChartElementsCurves', 'ChartElementsPoints', 'ChartElementsZoom', 'CompetitorFaresHoverOver', 'ChartElementsRectClip', 'ChartElementsVerticalLine', '$location', 'UserPreferencesService'];
module.exports = CompetitorFaresChart;